import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { api } from "../../api/api";
import { IQuizCurrentState, IQuizState } from ".";
import { IProfile } from "../profile/get-profile.handler";
import { now } from "../../utils/time";
import { ITicketsBalances } from "../../model/user-info.interface";

export interface IQuizTheme {
    id: number;
    name: string;
    description: string;
}

export interface IGetQuizResponse {
    quiz: IQuizCurrentState,
    themes: IQuizTheme[],
    profile: IProfile,
    tickets: Partial<ITicketsBalances>;
};

export const getQuiz = createAsyncThunk<IGetQuizResponse>(
    'quiz.getQuiz',
    async () => await api.quizzes.get()
);

const getQuizHandler = (builder: ActionReducerMapBuilder<IQuizState>) => {
    builder
        .addCase(getQuiz.pending, (state: IQuizState) => {
            state.loading = true;
            state.error = "";
        })
        .addCase(getQuiz.fulfilled, (state: IQuizState, action: PayloadAction<IGetQuizResponse>) => {
            state.loading = false;            
            state.themes = action.payload?.themes ?? [];
            state.quiz = action.payload?.quiz;

            state.ticketsRewards = action.payload?.tickets ?? {};

            if (state.quiz)
                state.deltaTime = now() - state.quiz.now;
        })
        .addCase(getQuiz.rejected, (state: IQuizState) => {
            state.loading = false;
            state.error = 'Unable to get quiz';
        });
};

export default getQuizHandler;